import { Injectable } from '@angular/core'
import { BehaviorSubject, delay, mergeMap, of } from 'rxjs'

@Injectable({ providedIn: 'root' })
export class LoadingService {
  private _loading = new BehaviorSubject<boolean>(false)
  public readonly loading$ = this._loading.pipe(
    mergeMap((isLoading) => {
      if (!isLoading) {
        return of(false)
      }
      return of(true).pipe(delay(1))
    })
  )

  constructor() {}

  show() {
    this._loading.next(true)
  }

  hide() {
    this._loading.next(false)
  }
}
